(() => {
  const init = (root) => {
    if (root.dataset.helpReady === 'true') return;
    root.dataset.helpReady = 'true';

    const buttons = [...root.querySelectorAll('[data-help-choice]')];
    const answers = [...root.querySelectorAll('[data-help-answer]')];
    const empty = root.querySelector('.ll-help-router__answers-empty');

    const showChoice = (button, moveFocus = true) => {
      const choice = button.dataset.helpChoice;
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        answers.forEach((answer) => {
          answer.hidden = answer.dataset.helpAnswer !== choice;
        });
        if (empty) empty.hidden = true;

        const selected = answers.find((answer) => answer.dataset.helpAnswer === choice);
        const heading = selected && selected.querySelector('h3');
        if (moveFocus && heading) heading.focus({ preventScroll: true });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        showChoice(button);
      });
    });

  };

  const initAll = () => document.querySelectorAll('[data-ll-help-router]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
